module.exports = __webpack_public_path__ + "assets/6d6c4b10848a7d79788dcccdf7b57f8d.mp3";